module.exports = __webpack_public_path__ + "img/icon-step@3x4.958e3a60.png";